import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSpatialPlanningAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitSpatialPlanningAssessmentResultInput;
}>;


export type SubmitSpatialPlanningAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitSpatialPlanningAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitSpatialPlanningAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & SpatialPlanningAssessmentResultFragment
    )> }
  ) }
);

export type SpatialPlanningAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | (
    { __typename: 'SpatialPlanningResult' }
    & SpatialPlanningAssessmentResultDataFragment
  ) | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type SpatialPlanningAssessmentResultDataFragment = (
  { __typename: 'SpatialPlanningResult' }
  & Pick<SchemaTypes.SpatialPlanningResult, 'correctAnswers' | 'incorrectAnswers' | 'accuracy' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SpatialPlanningTrialResult' }
    & Pick<SchemaTypes.SpatialPlanningTrialResult, 'index' | 'correctMoves' | 'respondedMoves' | 'numberOfAttempts' | 'responseTimeMs' | 'isCorrect'>
  )> }
);

export const SpatialPlanningAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SpatialPlanningAssessmentResultData on SpatialPlanningResult {
  trials {
    index
    correctMoves
    respondedMoves
    numberOfAttempts
    responseTimeMs
    isCorrect
  }
  correctAnswers
  incorrectAnswers
  accuracy
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const SpatialPlanningAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SpatialPlanningAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on SpatialPlanningResult {
      ...SpatialPlanningAssessmentResultData
    }
  }
  createdAt
}
    `;
export const SubmitSpatialPlanningAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitSpatialPlanningAssessmentResult($input: SubmitSpatialPlanningAssessmentResultInput!) {
  submitSpatialPlanningAssessmentResult(input: $input) {
    ... on SubmitSpatialPlanningAssessmentResultSuccessfulResponse {
      result {
        ...SpatialPlanningAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SpatialPlanningAssessmentResultFragmentDoc}
${SpatialPlanningAssessmentResultDataFragmentDoc}`;
export type SubmitSpatialPlanningAssessmentResultMutationFn = Apollo.MutationFunction<SubmitSpatialPlanningAssessmentResultMutation, SubmitSpatialPlanningAssessmentResultMutationVariables>;

/**
 * __useSubmitSpatialPlanningAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitSpatialPlanningAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSpatialPlanningAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSpatialPlanningAssessmentResultMutation, { data, loading, error }] = useSubmitSpatialPlanningAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSpatialPlanningAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSpatialPlanningAssessmentResultMutation, SubmitSpatialPlanningAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSpatialPlanningAssessmentResultMutation, SubmitSpatialPlanningAssessmentResultMutationVariables>(SubmitSpatialPlanningAssessmentResultDocument, options);
      }
export type SubmitSpatialPlanningAssessmentResultMutationHookResult = ReturnType<typeof useSubmitSpatialPlanningAssessmentResultMutation>;
export type SubmitSpatialPlanningAssessmentResultMutationResult = Apollo.MutationResult<SubmitSpatialPlanningAssessmentResultMutation>;
export type SubmitSpatialPlanningAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitSpatialPlanningAssessmentResultMutation, SubmitSpatialPlanningAssessmentResultMutationVariables>;